import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private apiUrl = `${environment.apiUrl}/api/newsletter/unsubscribe`;

  constructor(private http: HttpClient) {}

  unsubscribeUser(email: string): Observable<any> {
    return this.http.post(this.apiUrl, { email });
  }
}
